import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { fullName } from '../../../common/helpers/users';
import Money from '../../../common/money';
import { getById } from '../../../main/barbers/selector';
import Spinner from '../../../main/customers/customersList/spinner';
import { isCashOutTipsShortcutEnabled, paymentDepositsEnabled } from '../../selectors';
import CashTipsPayoutInput from './CashTipsPayoutInput';

const SalesSummary = props => (
  <div className="o-flexbox__item--flex-1 c-data-panel u-color-white u-p u-border-radius">
    <div className="c-summary-heading u-mb">
      <span className="c-label-new">
        {props.selectedBarberId ? `${fullName(props.selectedBarber)}'s summary` : 'Shop summary'}
      </span>
    </div>
    {props.isLoading
      ? (
        <div className="o-flexbox o-flexbox--justify-center">
          <Spinner />
        </div>
      )
      : (
        <Fragment>
          <div className="c-summary-item">
            <span>Sales</span>
            <span className="c-summary-amount">
              {props.totals && props.totals.totalTransactions}
            </span>
          </div>
          <div className="c-summary-item">
            <span>Net Sales - Services</span>
            <span className="c-summary-amount">
              <Money>{props.totals && props.totals.totalNetServiceSales}</Money>
            </span>
          </div>
          <div className="c-summary-item">
            <span>Net Sales - Products</span>
            <span className="c-summary-amount">
              <Money>{props.totals && props.totals.totalNetProductSales}</Money>
            </span>
          </div>
          {
            props.paymentDepositsEnabled && (
              <div className="c-summary-item">
            <span>Booking Deposits</span>
            <span className="c-summary-amount">
              <Money>{props.totals && props.totals.totalDeposits}</Money>
            </span>
            </div>
            )
          }
          <div className="c-summary-item">
            <span>Non-Cash Tips</span>
            <span className="c-summary-amount">
              <Money>{props.totals && props.totals.totalPosAndSquireTips}</Money>
            </span>
          </div>
          {
            props.showCashTips && (
              <section className="c-cash-tips-payouts">
                <header className="c-cash-tips-payouts-header u-mb-">
                  <span className="c-cash-tips-payouts-header__text">Tip payout</span>
                  <div className="c-info-tooltip-new c-info-tooltip-new_small c-info-tooltip-new-handler">
                    <div className="c-info-tooltip-new__content">
                      Populated amounts reflect total tips for the day and do not
                      account for any tips that were already paid out.
                    </div>
                  </div>
                </header>
                <CashTipsPayoutInput
                  selectedBarber={props.selectedBarber}
                  tipsToPayout={props.totals && props.totals.totalPosAndSquireTips}
                />
              </section>
            )
          }
        </Fragment>
      )}
  </div>
);

SalesSummary.propTypes = {
  selectedBarberId: PropTypes.string.isRequired,
  selectedBarber: PropTypes.object.isRequired,
  totals: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showCashTips: PropTypes.bool.isRequired,
  paymentDepositsEnabled: PropTypes.bool,
};


const mapStateToProps = (state, ownProps) => {
  const selectedBarber = getById(state, ownProps.selectedBarberId);

  return ({
    selectedBarber,
    showCashTips: isCashOutTipsShortcutEnabled(state) && selectedBarber,
    paymentDepositsEnabled: paymentDepositsEnabled(state),
  });
};

export default connect(mapStateToProps)(SalesSummary);
